import Service from '@/services/Service'

class OrderService extends Service {
  constructor() {
    super('ORDER')
    this.resource = 'mbcommerce/orders'
  }

  async sendPaymentConfirmation(payload) {
    const url = this.resource + '/payment-confirmation'
    return await this._http.post(url, payload)
  }
}

export default new OrderService()
